import { useGoals } from 'features/goals';
import { useLocalizedLifeAreas } from 'features/life-areas';
import React, { useRef, useState } from 'react';
import { HabitInsightsCard as HabitInsightsCardUi } from 'shared/components/ui/habit-insights-card';
import { useOpenTaskStatistics } from 'shared/contexts/task-detail';
import { useContextMenuState } from 'shared/hooks/use-context-menu-state';
import { useUser } from 'shared/hooks/use-user';
import { InsightsTimeframes } from 'shared/types/insights';

import { ContextMenu } from './context-menu';

export type InsightsCardProps = Omit<
  React.ComponentProps<typeof HabitInsightsCardUi>,
  'onMenuButton' | 'menuButtonRef' | 'goals' | 'lifeAreas' | 'onClick'
>;

export const InsightsCard: React.FC<InsightsCardProps> = ({
  habit,
  isPreview,
  ...rest
}) => {
  const user = useUser();
  const contextRef = useRef<HTMLDivElement>(null);
  const menuButtonRef = React.useRef<HTMLButtonElement>(null);
  const lifeAreas = useLocalizedLifeAreas();
  const goals = useGoals();
  const openTaskStatistics = useOpenTaskStatistics();

  const [menuButtonUsed, setMenuButtonUsed] = useState(false);
  const {
    open: openMenu,
    close: closeMenu,
    position: menuPosition,
  } = useContextMenuState({
    onClose: () => setMenuButtonUsed(false),
  });

  const openStatistics = () =>
    openTaskStatistics(
      habit,
      user?.settings?.insights?.timeframe ?? InsightsTimeframes.Year,
    );

  const openMenuByButton = (e: React.MouseEvent) => {
    setMenuButtonUsed(true);
    openMenu(e);
  };

  return (
    <>
      <HabitInsightsCardUi
        habit={habit}
        goals={goals}
        lifeAreas={lifeAreas}
        onMenuButton={openMenuByButton}
        menuButtonRef={menuButtonRef}
        onContextMenu={openMenu}
        onClick={isPreview ? undefined : openStatistics}
        isPreview={isPreview}
        {...rest}
      />
      {!!menuPosition && (
        <ContextMenu
          ref={contextRef}
          task={habit}
          onClose={closeMenu}
          referenceElement={menuButtonUsed ? menuButtonRef : undefined}
          location={menuButtonUsed ? undefined : menuPosition}
        />
      )}
    </>
  );
};
